export const getColors = color => {
  switch (color) {
    case '#1abc9c':
      return '#1abc9c';
    case '#2ecc71':
      return '#2ecc71';
    case '#3498db':
      return '#3498db';
    case '#9b59b6':
      return '#9b59b6';
    case '#34495e':
      return '#34495e';
    case '#16a085':
      return '#16a085';
    case '#27ae60':
      return '#27ae60';
    case '#2980b9':
      return '#2980b9';
    case '#8e44ad':
      return '#8e44ad';
    case '#2c3e50':
      return '#2c3e50';
    case '#f1c40f':
      return '#f1c40f';
    case '#e67e22':
      return '#e67e22';
    case '#e74c3c':
      return '#e74c3c';
    case '#ecf0f1':
      return '#FFC09F';
    case '#95a5a6':
      return '#95a5a6';
    case '#f39c12':
      return '#f39c12';
    case '#d35400':
      return '#d35400';
    case '#c0392b':
      return '#c0392b';
    case '#bdc3c7':
      return '#bdc3c7';
    case '#7f8c8d':
      return '#7f8c8d';
    default:
      return '#61d2ff';
  }
};
